import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { RouterModule, Routes } from '@angular/router';
import { BidTransporterComponent } from "./bid-transporter.component";
import { LayoutModule } from "../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { appService } from "../_services/app.service";
import { CommonService } from "../_services/common.service";
import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule, TranslateService, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { WaypointsMapModule } from "../map/WaypointsMap/Waypoints.module";
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const routes: Routes = [
    { path: '', component: BidTransporterComponent },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        LayoutModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        // WaypointsMapModule
    ],
    exports: [RouterModule],
    declarations: [BidTransporterComponent],
    providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class BidTransporterModule { }
